export const DEACTIVATE_AUTHORIZED_DEVICE = 'DEACTIVATE_AUTHORIZED_DEVICE';
export const DEACTIVATE_AUTHORIZED_DEVICE_RESULT = 'DEACTIVATE_AUTHORIZED_DEVICE_RESULT';
export const RENAME_AUTHORIZED_DEVICE = 'RENAME_AUTHORIZED_DEVICE';
export const RENAME_AUTHORIZED_DEVICE_RESULT = 'RENAME_AUTHORIZED_DEVICE_RESULT';
export const CREATE_AUTHORIZED_DEVICE = 'CREATE_AUTHORIZED_DEVICE';
export const CREATE_AUTHORIZED_DEVICE_RESULT = 'CREATE_AUTHORIZED_DEVICE_RESULT';
export const CREATE_EXTENDED_OFFLINE_TOKEN = 'CREATE_EXTENDED_OFFLINE_TOKEN';
export const CREATE_EXTENDED_OFFLINE_TOKEN_RESULT = 'CREATE_EXTENDED_OFFLINE_TOKEN_RESULT';
export const EXPORT_EXTENDED_OFFLINE_TOKEN_SAGA = 'EXPORT_EXTENDED_OFFLINE_TOKEN_SAGA';
export const EXPORT_EXTENDED_OFFLINE_TOKEN_SAGA_RESULT = 'EXPORT_EXTENDED_OFFLINE_TOKEN_RESULT';

// `result` is a boundary value: server response payload or Error, consumed as `any` by JS sagas.
type ActionResult = unknown;

export interface DeactivateAuthorizedDeviceAction {
  type: typeof DEACTIVATE_AUTHORIZED_DEVICE;
  payload: {
    userId?: string;
    deviceId?: string;
    costCenterId?: string;
    authorizedDevices?: unknown;
  };
}

export const deactivateAuthorizedDevice = (
  userId?: string,
  deviceId?: string,
  costCenterId?: string,
  authorizedDevices?: unknown,
): DeactivateAuthorizedDeviceAction => ({
  type: DEACTIVATE_AUTHORIZED_DEVICE,
  payload: {
    userId,
    deviceId,
    costCenterId,
    authorizedDevices,
  },
});

export interface DeactivateAuthorizedDeviceResultAction {
  type: typeof DEACTIVATE_AUTHORIZED_DEVICE_RESULT;
  payload: {
    success?: boolean;
    result?: ActionResult;
  };
}

export const deactivateAuthorizedDeviceResult = (
  success?: boolean,
  result?: ActionResult,
): DeactivateAuthorizedDeviceResultAction => ({
  type: DEACTIVATE_AUTHORIZED_DEVICE_RESULT,
  payload: {
    success,
    result,
  },
});

export interface RenameAuthorizedDeviceAction {
  type: typeof RENAME_AUTHORIZED_DEVICE;
  payload: {
    userId?: string;
    deviceId?: string;
    newName?: string;
  };
}

export const renameAuthorizedDevice = (
  userId?: string,
  deviceId?: string,
  newName?: string,
): RenameAuthorizedDeviceAction => ({
  type: RENAME_AUTHORIZED_DEVICE,
  payload: {
    userId,
    deviceId,
    newName,
  },
});

export interface RenameAuthorizedDeviceResultAction {
  type: typeof RENAME_AUTHORIZED_DEVICE_RESULT;
  payload: {
    success?: boolean;
    result?: ActionResult;
  };
}

export const renameAuthorizedDeviceResult = (
  success?: boolean,
  result?: ActionResult,
): RenameAuthorizedDeviceResultAction => ({
  type: RENAME_AUTHORIZED_DEVICE_RESULT,
  payload: {
    success,
    result,
  },
});

export interface CreateAuthorizedDeviceAction {
  type: typeof CREATE_AUTHORIZED_DEVICE;
  payload: {
    userId?: string;
    costCenterId?: string;
    productAccessId?: string;
    fingerprint?: string;
    deviceName?: string;
  };
}

export const createAuthorizedDevice = (
  userId?: string,
  costCenterId?: string,
  productAccessId?: string,
  fingerprint?: string,
  deviceName?: string,
): CreateAuthorizedDeviceAction => ({
  type: CREATE_AUTHORIZED_DEVICE,
  payload: {
    userId,
    costCenterId,
    productAccessId,
    fingerprint,
    deviceName,
  },
});

export interface CreateAuthorizedDeviceResultAction {
  type: typeof CREATE_AUTHORIZED_DEVICE_RESULT;
  payload: {
    success?: boolean;
    result?: ActionResult;
  };
}

export const createAuthorizedDeviceResult = (
  success?: boolean,
  result?: ActionResult,
): CreateAuthorizedDeviceResultAction => ({
  type: CREATE_AUTHORIZED_DEVICE_RESULT,
  payload: {
    success,
    result,
  },
});

export interface CreateExtendedOfflineTokenAction {
  type: typeof CREATE_EXTENDED_OFFLINE_TOKEN;
  payload: {
    userId?: string;
    authorizedDeviceId?: string;
    startDate?: string;
    endDate?: string;
    productAccessId?: string;
  };
}

export const createExtendedOfflineToken = (
  userId?: string,
  authorizedDeviceId?: string,
  startDate?: string,
  endDate?: string,
  productAccessId?: string,
): CreateExtendedOfflineTokenAction => ({
  type: CREATE_EXTENDED_OFFLINE_TOKEN,
  payload: {
    userId,
    authorizedDeviceId,
    startDate,
    endDate,
    productAccessId,
  },
});

export interface CreateExtendedOfflineTokenResultAction {
  type: typeof CREATE_EXTENDED_OFFLINE_TOKEN_RESULT;
  payload: {
    success?: boolean;
    result?: ActionResult;
  };
}

export const createExtendedOfflineTokenResult = (
  success?: boolean,
  result?: ActionResult,
): CreateExtendedOfflineTokenResultAction => ({
  type: CREATE_EXTENDED_OFFLINE_TOKEN_RESULT,
  payload: {
    success,
    result,
  },
});

export interface ExportExtendedOfflineTokenAction {
  type: typeof EXPORT_EXTENDED_OFFLINE_TOKEN_SAGA;
  payload: {
    primaryEmail?: string;
    password?: string;
    costCenterId?: string;
    productAccessId?: string;
    eotId?: string;
  };
}

export const exportExtendedOfflineToken = (
  primaryEmail?: string,
  password?: string,
  costCenterId?: string,
  productAccessId?: string,
  eotId?: string,
): ExportExtendedOfflineTokenAction => ({
  type: EXPORT_EXTENDED_OFFLINE_TOKEN_SAGA,
  payload: {
    primaryEmail,
    password,
    costCenterId,
    productAccessId,
    eotId,
  },
});

export interface ExportExtendedOfflineTokenResultAction {
  type: typeof EXPORT_EXTENDED_OFFLINE_TOKEN_SAGA_RESULT;
  payload: {
    success?: boolean;
    result?: ActionResult;
  };
}

export const exportExtendedOfflineTokenResult = (
  success?: boolean,
  result?: ActionResult,
): ExportExtendedOfflineTokenResultAction => ({
  type: EXPORT_EXTENDED_OFFLINE_TOKEN_SAGA_RESULT,
  payload: {
    success,
    result,
  },
});
